// External destinations opened in a new tab from within the app.
import { FooterLink } from '@/models/footer-link.ts';

// The Scribe start-page tile opens this in a new tab.
export const SCRIBE_URL = 'https://app.tandemhealth.ai/login';

// Static PDF served from `public/legal/`, linked in the Recall page footer.
export const RECALL_LEGAL_BASIS_PDF_URL = '/legal/leni-recall-datenschutz.pdf';

// Zammad knowledge base categories, linked as "Support" in the footer of the matching feature page.
export const RECALL_HELP_URL = 'https://eterno-health.zammad.com/#knowledge_base/1/locale/de-de/category/122';
export const CONNECT_HELP_URL = 'https://eterno-health.zammad.com/#knowledge_base/1/locale/de-de/category/123';
export const CAREVIEW_HELP_URL = 'https://eterno-health.zammad.com/#knowledge_base/1/locale/de-de/category/93';

export const IMPRESSUM_URL = 'https://www.eterno.health/dokumente/impressum';
export const SUPPORT_URL = 'https://eterno-health.zammad.com';
export const AI_NOTICE_URL = 'https://www.eterno.cloud/dokumente/ki-hinweise';

const IMPRESSUM_LINK: FooterLink = { href: IMPRESSUM_URL, label: 'Impressum' };
const AI_NOTICE_LINK: FooterLink = { href: AI_NOTICE_URL, label: 'KI-Kompetenz' };
const supportLink = (href: string): FooterLink => ({ href: href, label: 'Support' });

// Shown on every authenticated page without its own links (e.g. start page).
export const DEFAULT_FOOTER_LINKS: FooterLink[] = [IMPRESSUM_LINK, supportLink(SUPPORT_URL)];

export const CONNECT_FOOTER_LINKS: FooterLink[] = [IMPRESSUM_LINK, supportLink(CONNECT_HELP_URL), AI_NOTICE_LINK];

// Patientenblick has no knowledge base category yet, so it has no support link.
export const EXTRACTION_FOOTER_LINKS: FooterLink[] = [IMPRESSUM_LINK, AI_NOTICE_LINK];

export const RECALL_FOOTER_LINKS: FooterLink[] = [
    IMPRESSUM_LINK,
    supportLink(RECALL_HELP_URL),
    { href: RECALL_LEGAL_BASIS_PDF_URL, label: 'Datenschutzrechtliche Grundlage' },
];

export const CAREVIEW_FOOTER_LINKS: FooterLink[] = [IMPRESSUM_LINK, supportLink(CAREVIEW_HELP_URL)];
